<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @before-open="beforeOpen"
    >
      <template slot="menuLeft">
        <el-button
          type="warning"
          size="small"
          icon="el-icon-refresh"
          :loading="syncLoading"
          @click="handleSync"
        >手动同步</el-button>
        <el-button
          type="default"
          size="small"
          plain
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >导出</el-button>
      </template>

      <template slot="processStatus" slot-scope="{ row }">
        <el-tag :type="getProcessStatusType(row.processStatus)" size="small">
          {{ getProcessStatusText(row) }}
        </el-tag>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-view" @click="handleView(row)">
          详情
        </el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, syncLatest, exportExcel } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";
import { downloadXls } from "@/util/util";

export default {
  name: "system-device-inspection-error",
  mixins: [crudMixins],
  data () {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      syncLoading: false,
      exportLoading: false,
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 90,
        dialogWidth: "900px",
        dialogHeight: "700px",
        column: [
          {
            label: "设备名称",
            prop: "deviceName",
            minWidth: 160,
            overHidden: true,
            search: true,
            searchSpan: 6,
            searchPlaceholder: "请输入设备名称",
            viewDisplay: true,
          },
          {
            label: "任务名称",
            prop: "taskName",
            minWidth: 180,
            overHidden: true,
            search: true,
            searchSpan: 6,
            searchPlaceholder: "请输入任务名称",
            viewDisplay: true,
          },
          {
            label: "任务类型",
            prop: "taskType",
            minWidth: 110,
            type: "select",
            search: true,
            searchSpan: 6,
            dataType: "number",
            dicData: [
              { label: "临时任务", value: 0 },
              { label: "日常巡检", value: 1 },
              { label: "周巡检", value: 3 },
            ],
            props: {
              label: "label",
              value: "value",
            },
            formatter: (row) => row.taskTypeName || row.taskType,
            viewDisplay: true,
          },
          {
            label: "检查内容",
            prop: "patrolContent",
            type: "textarea",
            minWidth: 220,
            span: 24,
            overHidden: true,
            viewDisplay: true,
          },
          {
            label: "标准值",
            prop: "stdValue",
            minWidth: 120,
            overHidden: true,
            viewDisplay: true,
          },
          {
            label: "实际值",
            prop: "actualValue",
            minWidth: 120,
            overHidden: true,
            viewDisplay: true,
          },
          {
            label: "单位",
            prop: "unit",
            width: 80,
            align: "center",
            viewDisplay: true,
          },
          {
            label: "巡检时间",
            prop: "inspectionTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            minWidth: 170,
            viewDisplay: true,
          },
          {
            label: "巡检人",
            prop: "inspectionUserName",
            width: 110,
            align: "center",
            viewDisplay: true,
          },
          {
            label: "处理状态",
            prop: "processStatus",
            type: "select",
            slot: true,
            width: 110,
            align: "center",
            search: true,
            searchSpan: 6,
            dataType: "number",
            dicData: [
              { label: "无法处理", value: -1 },
              { label: "未处理", value: 0 },
              { label: "已处理", value: 1 },
            ],
            props: {
              label: "label",
              value: "value",
            },
            viewDisplay: true,
          },
          {
            label: "处理结果",
            prop: "processResult",
            type: "textarea",
            minWidth: 220,
            span: 24,
            overHidden: true,
            hide: true,
            viewDisplay: true,
          },
          {
            label: "处理人",
            prop: "processUserName",
            width: 110,
            align: "center",
            viewDisplay: true,
          },
          {
            label: "处理时间",
            prop: "processTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            minWidth: 170,
            viewDisplay: true,
          },
          {
            label: "最近同步时间",
            prop: "lastSyncTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            minWidth: 170,
            viewDisplay: true,
          },
          {
            ...searchTimeConfig,
            label: "巡检时间",
            paramsKey: ["startTime", "endTime"],
            search: true,
          },
        ]
      },
    }
  },
  methods: {
    handleView(row) {
      this.form = row
      this.$refs.crud.rowView(row)
    },
    async handleSync() {
      try {
        await this.$confirm("将拉取最近7天点检异常并覆盖更新本地记录，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
      } catch (e) {
        return
      }
      this.syncLoading = true
      try {
        const res = await syncLatest({ syncDays: 7 })
        const data = (res.data && res.data.data) || {}
        this.$message.success(`同步完成：新增${data.insertCount || 0}条，更新${data.updateCount || 0}条，跳过${data.skipCount || 0}条`)
        this.onLoad(this.page, this.query)
      } catch (e) {
        console.warn(e)
        this.$message.error(this.getErrorMessage(e, "同步失败"))
      } finally {
        this.syncLoading = false
      }
    },
    async handleExport() {
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `设备点检异常_${Date.now()}.xlsx`)
        this.$message.success("导出成功")
      } catch (e) {
        console.warn(e)
        this.$message.error(this.getErrorMessage(e, "导出失败"))
      } finally {
        this.exportLoading = false
      }
    },
    getErrorMessage(error, fallback) {
      const data = error && error.response && error.response.data
      const message = (data && (data.msg || data.message)) || (error && error.msg) || (error && error.message) || String(error || "") || fallback
      return String(message).replace(/^(Error:\s*)+/i, "")
    },
    getProcessStatusText(row) {
      return row.processStatusName || ({ "-1": "无法处理", 0: "未处理", 1: "已处理" }[row.processStatus] || row.processStatus || "-")
    },
    getProcessStatusType(status) {
      if (status === 1) return "success"
      if (status === -1) return "warning"
      return "danger"
    },
  },
}
</script>

<style scoped lang="scss">
</style>
